/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { MESSAGES } from "../../../utlis/messages";



export const FetchSettings = createAsyncThunk(
    "FetchSettings",
    async (_, { rejectWithValue, dispatch, getState }) => {
      try {
        const response = await customAxios('application/json', dispatch).get(`fetchSettings`);
        return response.data;
      } catch (error: any) {
        errorMessage(error?.response?.data?.error || MESSAGES.SOME_WENT_WRONG)
        return rejectWithValue(error.response.data);
      }
    }
  );
  export const UpdateSettings = createAsyncThunk(
    "UpdateSettings",
    async (settings: { isMultiLanguage: boolean; defaultLanguage: string },{ rejectWithValue, dispatch, getState }) => {
      try {
        const response = await customAxios('application/json', dispatch).put(`updateSettings`, {isMultiLanguage:settings?.isMultiLanguage,defaultLanguage:settings?.defaultLanguage});
        successMessage(response.data.message.details);
        
        return response.data;
      } catch (error: any) {
        errorMessage(error?.response?.data?.error || MESSAGES.SOME_WENT_WRONG)
        return rejectWithValue(error.response.data);
      }
    }
  );
  

export const FetchAppVersion = createAsyncThunk(
  "FetchAppVersion",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`fetchAppVersion`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);


export const UpdateAppVersion = createAsyncThunk(
  "UpdateSettings",
  async (values:any,{ rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).put(`updateVersion`, values);
      successMessage(response.data.message.details);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || MESSAGES.SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);